var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.groupitem.image && this.groupitem.image.filepath !== null
    ? _c(
        "div",
        { staticClass: "teaser-image cell" },
        [
          _vm.linkUrl
            ? _c(
                "generic-link",
                { attrs: { href: _vm.linkUrl } },
                [
                  _c("AImage", {
                    attrs: {
                      img: _vm.image,
                      ratio: _vm.ratio,
                      alt: _vm.alt,
                      title: _vm.title,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "no-image-link" },
                [
                  _c("AImage", {
                    attrs: {
                      img: _vm.image,
                      ratio: _vm.ratio,
                      alt: _vm.alt,
                      title: _vm.title,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }